module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"admin":"Admin","quotation":"Create Quotation","quotation_list":"List Quotation","signout":"Sign Out"},"si":{"admin":"පරිපාලක","quotation":"මිල කියවුම්","quotation_list":"මිල කැඳවුම් ලැයිස්තුව","signout":"ඉවත් වන්න"},"ta":{"admin":"පරිපාලක","quotation":"விலைக்கோரலின்","quotation_list":"விலைக்கோரலின் பட்டியல்","signout":"வெளியேறு"}}')
  delete Component.options._Ctor
}
